<!-- success -->
<template>
  <div id='successPage'>
    <div class="wrap">
      <img src="/img/success.png" alt="success" class="success">
      <h5 class="h5">报名提交成功</h5>
      <p class="p">未来魔法校要对提交的人员进行审核，请及时查看审核结果</p>
      <button class="app-btn" @click="goBack">返回</button>
    </div>
  </div>
</template>

<script>
import api from '@/services/server.js'
import { parseUrl } from '@/utils'
import { getUser } from '@/utils/auth'
export default {
  data () {
    return {
      params: {},
      info: {}
    }
  },
  components: {},
  mounted () {
    // window.parent.postMessage(window.location.href, '*')
    // http://10.33.34.31:8080/success
    // ?field_1=%E5%93%88%E5%93%88%E5%93%88
    // &field_3=13333332222%40163.com
    // &jamr_h=LS0tCi0gYjBLV0FUCi0gejZxU1NYTEEKLSAhcnVieS9vYmplY3Q6QWN0aXZlU3VwcG9ydDo6VGltZVdpdGhab25lCiAgdXRjOiAyMDE4LTA5LTEzIDAyOjUxOjMxLjI5OTA1MTU4OSBaCiAgem9uZTogIXJ1Ynkvb2JqZWN0OkFjdGl2ZVN1cHBvcnQ6OlRpbWVab25lCiAgICBuYW1lOiBBc2lhL1NoYW5naGFpCiAgdGltZTogMjAxOC0wOS0xMyAxMDo1MTozMS4yOTkwNTE1ODkgWgo%3D--bfab867669072e46ef98040bfa60a3ae
    // &serial_number=5
    let url = window.location.href
    this.params = parseUrl(url)
    this.info = parseUrl(window.parent.location.href)
    this.setParams(this.params)
    let params = {
      campsite_id: this.info.campsite_id,
      id: this.info.id,
      campsite_type: this.info.type,
      school_id: getUser().school_id,
      name: this.params.name,
      email: this.params.email,
      serial_number: this.params.serial_number
    }
    api.receive(params).then(res => {
    })
  },
  methods: {
    goBack () {
      window.parent.location.href = process.env.VUE_APP_MAIN_URL
    },
    setParams (params) {
      for (var key in params) {
        // 包含filed是名字和邮箱
        if (key.indexOf('field') !== -1) {
          // 确定邮箱
          if (params[key].indexOf('@') !== -1) {
            params.email = params[key]
          } else {
            // 确定名字
            params.name = params[key]
          }
        }
      }
      return params
    }
  }
}
</script>
<style scoped lang='scss'>
#successPage {
  .wrap {
    width: 870px;
    height: 498px;
    background: rgba(255, 255, 255, 1);
    border-radius: 12px;
    box-shadow: 0px 8px 32px 0px rgba(238, 238, 238, 0.6);
    margin: 0 auto;
    margin-top: 60px;
    .success {
      width: 66px;
      height: 66px;
      margin-top: 120px;
      margin-bottom: 30px;
    }
    .h5 {
      font-size: 24px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      margin-bottom: 21px;
    }
    .p {
      color: rgba(102, 102, 102, 1);
      line-height: 24px;
      margin-bottom: 78px;
    }
  }
}
</style>
